class Storefinder extends HTMLElement {
  constructor() {
    super();

    this.mapElement = this.querySelector('#map');

    this.map = new google.maps.Map(this.mapElement, {
        zoom: 7,
        center: { lat: 52.632469, lng: -1.689423 },
    });
  }
}

customElements.define('store-finder', Storefinder);